import React from 'react'
import PropTypes from 'prop-types'

const classNames = require('classnames')

const GlgModal = ({ children, onClose = () => {}, contentClassName = '' }) => {
  const onClickOutside = (event) => {
    event.stopPropagation()
    onClose()
  }

  return (
    <div className="glg-modal-overlay" onClick={onClickOutside}>
      <div
        className={classNames('glg-modal-content', contentClassName)}
        onClick={(e) => e.stopPropagation()}>
        {children}
      </div>
    </div>
  )
}


GlgModal.propTypes = {
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func,
  contentClassName: PropTypes.string,
}
export default GlgModal
